import joi from '@blockcatio/tabby-library/lib/services/joi';
import SelectInputAddNew from '@blockcatio/tabby-library/lib/components/form/elements/SelectInputAddNew';
import TextInput from '@blockcatio/tabby-library/lib/components/form/elements/TextInput';
import createForm from '@blockcatio/tabby-library/lib/components/form/createForm';

import CustomTokenForm from '../../components/modals/CustomTokenForm';

const ConfigurationForm = ({
  name,
  tokenList,
  tokenOptions,
  tokenAddress,
  onSelectFormSubmit,
  onValidateTokenAddress,
  tokensPerCode,
  numberOfCodes,
  ...props
}) =>
  createForm({
    ...props,
    formClassName: 'configure-form',
    fields: [
      {
        id: 'name',
        label: 'Name',
        inputComponent: TextInput,
        inputOptions: {
          placeholder: 'Mega CAT Giveaway!',
        },
        required: true,
        validation: joi.string().required(),
        defaultValue: name || undefined,
      },
      {
        id: 'tokenAddress',
        label: 'Token',
        inputComponent: SelectInputAddNew,
        required: true,
        inputOptions: {
          placeholder: 'Select a Token',
          options: tokenOptions,
          formComponent: CustomTokenForm,
          onFormSubmit: onSelectFormSubmit,
          formProps: {
            onValidateTokenAddress,
          },
        },
        validation: joi
          .ethereumAddress()
          .insensitive()
          .required(),
        defaultValue: tokenAddress || undefined,
      },
      {
        id: 'tokensPerCode',
        label: 'Tokens per Code',
        inputComponent: TextInput,
        inputOptions: {
          placeholder: '500',
        },
        required: true,
        validation: joi
          .number()
          .integer()
          .positive()
          .max(1000000000)
          .required(),
        defaultValue: tokensPerCode || undefined,
      },
      {
        id: 'numberOfCodes',
        label: 'Number of Codes',
        inputComponent: TextInput,
        inputOptions: {
          placeholder: '100',
        },
        required: true,
        validation: joi
          .number()
          .integer()
          .positive()
          .required(),
        defaultValue: numberOfCodes || undefined,
      },
    ],
    submitText: 'Next',
  });

ConfigurationForm.displayName = 'ConfigurationForm';

export default ConfigurationForm;



// WEBPACK FOOTER //
// ./src/containers/createCampaign/ConfigurationForm.js